const { createBrowserHistory } = require('history');

module.exports = createBrowserHistory();
